/* eslint-disable */
import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";

import { useTranslation } from "react-i18next";

// Material UI table
import { MaterialReactTable } from "material-react-table";
//Material UI components for rendring menu and others
import { Box, MenuItem } from "@mui/material";

/*import url and gateway methods */
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import AddLabelModal from "components/Common/Modal/AddLabelModal";
import AccessDeniedView from "components/Common/AccessDeniedView/AccessDeniedView";

//import images
import { assetImages } from "constants";

import TabsHeader from "components/Common/TabsHeader/TabsHeader";

//import common header objects
import { commonHeaderLinkLists } from "helper/ClinicalManagementHelper/ClinicalManagementHelper";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import { createContactChatHandler } from "helper/AppUserHelper/AppUserHelper";
import { replaceListByIds, updateListByIds } from "helper/Common/CommonHelper";
import { removeTagHandler } from "helper/TagHelper/TagHelper";

import PatientListHeader from "components/ClinicalManagement/Patients/PatientListHeader/PatientListHeader";
import { getPublicIP } from "helper/AuthHelper/AuthHelper";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";
import UserListFilterPopup from "../Common/Popup/UserListFilterPopup";
import ConversationNewMailPopup from "components/Common/Popup/ConversationNewMailPopup";

const PatientsListBody = () => {
  /* ------------- Language translation imports starts here ------------- */
  const { t, i18n } = useTranslation();

  const moduleAccess = localStorage.getItem("moduleaccess");
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [isLoading, setIsLoading] = useState(false);
  const [appUserList, setAppUserList] = useState([]);

  const [rowSelection, setRowSelection] = useState({});
  const [selectedUserIds, setSelectedUserIds] = useState([]);
  const [selectedUserEmails, setSelectedUserEmails] = useState("");
  const [selectedTagId, setSelectedTagId] = useState(null);
  const [selectedUserId, setSelectedUserId] = useState(null);

  const [isFilterReset, setIsFilterReset] = useState(false);
  const [jsonFilterQuery, setJsonFilterQuery] = useState([]);
  const [reloadData, setReloadData] = useState(false);

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  //function for get all contacts
  const getAllAppUsers = async () => {
    setRowSelection({});
    setSelectedUserIds([]);
    setSelectedUserEmails("");

    try {
      setIsLoading(true);

      const userPublicIp = await getPublicIP();

      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_USER_LIST_BY_USER +
        `?userip=${userPublicIp}&modulefrom=backend&filterroleslug=PATIENT`;

      if (jsonFilterQuery.length > 0) {
        // Sanitize the jsonFilterQuery
        const sanitizedQuery = jsonFilterQuery.map((filter) => {
          if (
            (filter.operator === "includes" ||
              filter.operator === "excludes") &&
            Array.isArray(filter.value)
          ) {
            return {
              ...filter,
              value: filter.value.map((item) => item.value).join(","), // Extract and join values as a comma-separated string
            };
          }
          return filter;
        });

        requestUrl += `&filters=${encodeURIComponent(
          JSON.stringify(sanitizedQuery)
        )}`;
      }

      console.log("url of app user list------>", requestUrl);

      const response = await getData(requestUrl);

      console.log("response in app user list------>", response);

      setIsLoading(false);

      if (response.status) {
        setMessageType("success");
        setAppUserList(response.data);
      } else {
        setMessageType("error");
      }

      setAlertMessage(response.message);
    } catch (error) {
      // console.log(error.message);
      setAlertMessage(error.message);
      setMessageType("error");
    }

    setShowAlert(true);
  };

  //* function for change rank
  const rankInputChangeHandler = (row, value) => {
    const updatedUserList = [...appUserList];

    const rowIndex = updatedUserList.findIndex(
      (user) => user._id === row.original._id
    );

    if (rowIndex !== -1) {
      updatedUserList[rowIndex].rank = value;

      setAppUserList(updatedUserList);
    }
  };

  //* function for update rank
  const updateRankHandler = async (e) => {
    if (selectedUserIds.length > 0) {
      const userPublicIp = await getPublicIP();

      const userListToBeUpdate = appUserList.filter((item) =>
        selectedUserIds.includes(item._id)
      );

      let userData = {
        userlist: userListToBeUpdate,
      };

      let requestURL =
        url.API_BASE_URL +
        url.API_BULK_UPDATE_USER +
        `?userip=${userPublicIp}`;

      const response = await putData(requestURL, userData);

      console.log(response);

      if (response.status) {
        setMessageType("success");

        setTimeout(() => {
          setSelectedUserIds([]);
          setRowSelection({});
          setSelectedUserEmails("");
        }, 1500);
      } else {
        setMessageType("error");
      }

      setAlertMessage(response.message);
    } else {
      setMessageType("error");
      setAlertMessage("Please select user for change rank");
      setShowAlert(true);
    }
  };

  //function for reset
  const resetAndReload = () => {
    setIsFilterReset(true);
    setJsonFilterQuery([]);
    setReloadData(true);
  };

  useEffect(() => {
    if (reloadData) {
      getAllAppUsers();
      setReloadData(false);
    }
  }, [reloadData]);

  useEffect(() => {
    if (jsonFilterQuery.length > 0) {
      getAllAppUsers();
    }
  }, [jsonFilterQuery]);

  useEffect(() => {
    getAllAppUsers();
  }, []);

  /*
   * Material React Table Column and States -----------------------------------------------------------
   *---------------------------------------------------------------------------------------------------
   */

  const columns = useMemo(() => {
    const baseColumns = [
      {
        accessorKey: "name",
        header: t("Name"),
        Cell: ({ row }) => (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
              width: "150px",
            }}
          >
            <img
              height={30}
              width={30}
              src={
                row.original.image
                  ? url.SERVER_URL + row.original.image
                  : assetImages.defaultUser
              }
              loading="lazy"
              style={{ borderRadius: "50%" }}
            />
            <span>{row.original.name}</span>
          </Box>
        ),
      },
      {
        accessorKey: "surname",
        header: t("Surname"),
      },
      {
        accessorKey: "rolestring",
        header: t("Role"),
      },
      {
        accessorKey: "email",
        header: t("Email"),
      },
      {
        accessorKey: "position",
        header: t("Position"),
      },
      {
        accessorKey: "company",
        header: t("Clinic"),
      },
      {
        accessorKey: "costperhour",
        header: t("Cost"),
      },
      {
        accessorKey: "phone",
        header: t("Phone"),
      },
      {
        accessorKey: "city",
        header: t("Location"),
      },
      {
        accessorKey: "country",
        header: t("Country"),
      },
    ];
    if (
      userInfo.role.slug === "ADMIN" ||
      userInfo.role.slug === "SUPER_ADMIN"
    ) {
      baseColumns.splice(3, 0, {
        accessorKey: "rank",
        header: t("Rank"),
        Cell: ({ row }) => (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
              width: "120px",
            }}
          >
            <input
              type="number"
              name="rank"
              id="rank"
              value={row.original.rank}
              onChange={(e) => rankInputChangeHandler(row, e.target.value)}
              className="form-control fs-sm text-gray bg-white py-2 border-gray-300 shadow-none"
            />
          </Box>
        ),
      });
    }
    return baseColumns;
  }, [appUserList, i18n.language, userInfo.role.slug]);

  useEffect(() => {
    //do something when the row selection changes...
    // console.info("rowSelection", rowSelection);
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key]
    );
    if (selectedIdsArray.length > 0) {
      const selectUserIds = selectedIdsArray.map((id) => {
        const [userId] = id.split("-");
        return userId;
      });
      const selectUserEmails = selectedIdsArray.map((id) => {
        const [, userEmail] = id.split("-");
        return userEmail;
      });
      setSelectedUserIds(selectUserIds);
      const selectUserEmailString = selectUserEmails.join(",");
      setSelectedUserEmails(selectUserEmailString);
    } else {
      setSelectedUserIds([]);
    }
  }, [rowSelection]);

  /* Closes the alert by updating the state variables.*/
  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    moduleAccess.includes("MOD_PATIENT_MANAGEMENT")
  ) {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          <TabsHeader
            commonHeaderObject={commonHeaderLinkLists(t)}
            activeOption={t("Patient")}
          />
          <div className="container-fluid px-lg-5">
            <PatientListHeader
              reloadList={resetAndReload}
              updateRankHandler={updateRankHandler}
              selectedItemIds={selectedUserIds}
              jsonFilterQuery={jsonFilterQuery}
            />

            {isLoading ? (
              <LoadingSkeleton />
            ) : (
              <div className="table-wrapper">
                <MaterialReactTable
                  columns={columns} // map columns to be displayed with api data,
                  data={appUserList} // data from api to be displayed
                  enableGrouping // to enable grouping of column
                  enableRowSelection // enable showing checkbox
                  getRowId={(row) => `${row._id}-${row.email}`} // map which value to select with row checkbox
                  onRowSelectionChange={setRowSelection} //connect internal row selection state to your own
                  state={{ rowSelection }} //pass our managed row selection state to the table to use
                  muiTableContainerProps={{
                    sx: {
                      maxHeight: "60vh",
                    },
                  }}
                  enableStickyHeader
                />
              </div>
            )}
          </div>

          <UserListFilterPopup
            setJsonFilterQuery={setJsonFilterQuery}
            reloadLeadList={resetAndReload}
            moduleSlug="patientlist"
            isFilterReset={isFilterReset}
            setIsFilterReset={setIsFilterReset}
          />

          <ConversationNewMailPopup
            contactPersonEmail={selectedUserEmails}
            setShowAlert={setShowAlert}
            setAlertMessage={setAlertMessage}
            setMessageType={setMessageType}
          />

          {showAlert && (
            <AlertNotification
              showAlert={showAlert}
              message={alertMessage}
              alertType={messageType}
              onClose={onAlertClose}
            />
          )}
        </section>
      </div>
    );
  } else {
    return <AccessDeniedView />;
  }
};

export default PatientsListBody;
